// Merkezi API konfigürasyonu
const API_BASE_URL = process.env.REACT_APP_API_URL || "";

export const API_ENDPOINTS = {
  // Genel API'ler
  RESULTS: `${API_BASE_URL}/get-results`,
  QUESTIONS: `${API_BASE_URL}/get-questions`,
  QUESTIONS_BY_COURSE: (courseId) => `${API_BASE_URL}/get-questions-by-course/${courseId}`,
  ADD_QUESTION: `${API_BASE_URL}/add-question`,
  UPDATE_QUESTION: `${API_BASE_URL}/update-question`,
  DELETE_QUESTION: `${API_BASE_URL}/delete-question`,
  SAVE_SINGLE_QUESTION: `${API_BASE_URL}/save-single-question`,

  // Syllabus API'leri
  ADD_SYLLABUS: `${API_BASE_URL}/add-syllabus`,
  DELETE_SYLLABUS: `${API_BASE_URL}/delete-syllabus`,
  GET_SYLLABUS: `${API_BASE_URL}/get-syllabus`,
  COURSE_SYLLABUS_PDF: (programId, courseCode) => `${API_BASE_URL}/api/programs/${programId}/courses/${encodeURIComponent(courseCode)}/syllabus-pdf`,

  // Program ve Ders API'leri
  FACULTIES: `${API_BASE_URL}/api/faculties`,
  PROGRAMS: `${API_BASE_URL}/api/programs`,
  COURSES: `${API_BASE_URL}/api/courses`,
  COURSE_OUTCOMES: (courseId) => `${API_BASE_URL}/api/course-outcomes/${courseId}`,
  PROGRAM_OUTCOMES: (programId) => `${API_BASE_URL}/api/program-outcomes/${programId}`,
  EDUCATION_TYPES: `${API_BASE_URL}/api/education-types`,
  EXAM_TYPES: `${API_BASE_URL}/api/exam-types`,

  // Akademisyen API'leri
  AKADEMISYEN_LOGIN: `${API_BASE_URL}/api/akademisyen/login`,
  AKADEMISYEN_REGISTER: `${API_BASE_URL}/api/akademisyen/register`,
  AKADEMISYEN_COURSES: `${API_BASE_URL}/api/akademisyen/courses`,
  AKADEMISYEN_COURSES_DETAILED: `${API_BASE_URL}/api/akademisyen/courses-detailed`,
  AKADEMISYEN_PERMISSIONS: `${API_BASE_URL}/api/akademisyen/permissions`,
  AKADEMISYEN_GUNCEL: `${API_BASE_URL}/api/akademisyen/guncel`,
  AKADEMISYEN_GUNCEL_BY_ID: (id) => `${API_BASE_URL}/api/akademisyen/guncel/${id}`,
  AKADEMISYEN_ASSIGN_COURSE: `${API_BASE_URL}/api/akademisyen/assign-course`,
  AKADEMISYEN_REMOVE_COURSE: `${API_BASE_URL}/api/akademisyen/remove-course`,
  AKADEMISYEN_ASSIGNED_COURSES: (id) => `${API_BASE_URL}/api/akademisyen/assigned-courses/${id}`,
  AKADEMISYEN_ASSIGNED_COURSES_DETAILED: (id) => `${API_BASE_URL}/api/akademisyen/assigned-courses-detailed/${id}`,
  AKADEMISYEN_ACTIVE: `${API_BASE_URL}/api/akademisyen/active`,
  AKADEMISYEN_INACTIVE: `${API_BASE_URL}/api/akademisyen/inactive`,
  AKADEMISYEN_DEACTIVATE: (id) => `${API_BASE_URL}/api/akademisyen/${id}/deactivate`,
  AKADEMISYEN_ACTIVATE: (id) => `${API_BASE_URL}/api/akademisyen/${id}/activate`,

  // Şifre Sıfırlama API'leri
  REQUEST_PASSWORD_RESET_CODE: `${API_BASE_URL}/api/auth/request-password-reset-code`,
  VERIFY_PASSWORD_CODE: `${API_BASE_URL}/api/auth/verify-code`,
  RESET_PASSWORD_WITH_CODE: `${API_BASE_URL}/api/auth/reset-password-with-code`,

  // Admin API'leri
  ADMIN_LOGIN: `${API_BASE_URL}/api/admin/login`,
  ADMIN_LOGOUT: `${API_BASE_URL}/api/admin/logout`,
  ADMIN_REGISTER: `${API_BASE_URL}/api/admin/register`,
  ADMIN_RESET_PASSWORD: `${API_BASE_URL}/api/admin/reset-password`,
  ADMIN_AUTO_ASSIGN_COURSES: `${API_BASE_URL}/api/admin/auto-assign-courses`,
  ADMIN_ADVANCE_ACADEMIC_YEAR: `${API_BASE_URL}/api/admin/academic-years/advance`,
  ADMIN_ACTIVATE_ACADEMIC_YEAR: `${API_BASE_URL}/api/admin/academic-years/activate`,
  ADMIN_ACADEMIC_YEAR_PREFLIGHT: (year) => `${API_BASE_URL}/api/admin/academic-years/${year}/preflight`,
  PRETEST_PERMISSION: `${API_BASE_URL}/api/admin/pretest-permission`,
  LEARNING_OUTCOMES_EDIT_PERMISSION: `${API_BASE_URL}/api/admin/learning-outcomes-edit-permission`,
  SYLLABUS_UPLOAD_PERMISSION: `${API_BASE_URL}/api/admin/syllabus-upload-permission`,

  // Rol API'leri
  ROLES_TYPES: `${API_BASE_URL}/api/roles/types`,
  ROLES_FACULTIES: `${API_BASE_URL}/api/roles/faculties`,
  ROLES_PROGRAMS: (facultyId) => `${API_BASE_URL}/api/roles/programs/${facultyId}`,
  ROLES_AKADEMISYEN: `${API_BASE_URL}/api/roles/akademisyen`,
  ROLES_ASSIGN: `${API_BASE_URL}/api/roles/assign`,
  ROLES_ASSIGNMENTS: `${API_BASE_URL}/api/roles/assignments`,
  ROLES_DEACTIVATE: (id) => `${API_BASE_URL}/api/roles/deactivate/${id}`,
  ROLES_CHECK_DEKAN: (id) => `${API_BASE_URL}/api/roles/check-dekan/${id}`,
  ROLES_CHECK_PROGRAM_BASKANI: (id) => `${API_BASE_URL}/api/roles/check-program-baskani/${id}`,

  // Sınav sonuçları API'leri
  DEKAN_EXAM_RESULTS: `${API_BASE_URL}/api/dekan/exam-results`,
  DEKAN_COURSE_RESULTS: (courseId) => `${API_BASE_URL}/api/dekan/course-results/${courseId}`,
  PROGRAM_BASKANI_EXAM_RESULTS: `${API_BASE_URL}/api/program-baskani/exam-results`,
  PROGRAM_BASKANI_COURSE_RESULTS: (courseId) => `${API_BASE_URL}/api/program-baskani/course-results/${courseId}`,
  REKTOR_EXAM_RESULTS: `${API_BASE_URL}/api/rektor/exam-results`,
  REKTOR_COURSE_RESULTS: (courseId) => `${API_BASE_URL}/api/rektor/course-results/${courseId}`,
  PREVIOUS_EXAM_RESULTS: `${API_BASE_URL}/api/previous-exam-results`,

  // Öğrenci API'leri
  STUDENT_EXAM_LEARNING: `${API_BASE_URL}/api/student-exam-learning`,
  STUDENT_EXAM_SCORE: `${API_BASE_URL}/api/student-exam-score`,
  STUDENT_EXAM_SCORES_BATCH: `${API_BASE_URL}/api/student-exam-scores/batch`,
  STUDENT_EXAMS_BY_TYPE: `${API_BASE_URL}/api/student-exams-by-type`,
  STUDENT_LEARNING_OUTCOMES: `${API_BASE_URL}/api/student-learning-outcomes`,
  STUDENT_PROGRAM_OUTCOMES: `${API_BASE_URL}/api/student-program-outcomes`,

  // Dosya yükleme API'leri
  UPLOAD_QUESTIONS_EXCEL: `${API_BASE_URL}/upload-questions-excel`,
  QUESTION_IMAGE: (id) => `${API_BASE_URL}/api/questions/${id}/image`,
  UPLOAD_CLASS_ROSTER: `${API_BASE_URL}/api/upload-class-roster`,
  SAVE_STUDENT_OUTCOME_ANALYSIS: `${API_BASE_URL}/save-student-outcome-analysis`,

  // Course Content Permissions API'leri
  COURSE_PERMISSIONS: (courseId) => `${API_BASE_URL}/api/admin/course-permissions/${courseId}`,
  COURSE_PERMISSIONS_GRANT_ALL: (courseId) => `${API_BASE_URL}/api/admin/course-permissions/${courseId}/grant-all`,
  COURSE_PERMISSIONS_REVOKE_ALL: (courseId) => `${API_BASE_URL}/api/admin/course-permissions/${courseId}/revoke-all`,
  COURSE_PERMISSIONS_GRANT: (courseId) => `${API_BASE_URL}/api/admin/course-permissions/${courseId}/grant`,
  COURSE_PERMISSIONS_REVOKE: (courseId) => `${API_BASE_URL}/api/admin/course-permissions/${courseId}/revoke`,
  ALL_ACADEMICS: `${API_BASE_URL}/api/admin/academics`,
  ACADEMIC_COURSE_PERMISSION: (courseId) => `${API_BASE_URL}/api/academic/course-permission/${courseId}`,
  UPDATE_WEEKLY_TOPICS: (courseId) => `${API_BASE_URL}/api/course-content/${courseId}/weekly-topics`,
  PROCESS_UPLOAD: `${API_BASE_URL}/process-upload`,
  LIST_UPLOADS: `${API_BASE_URL}/list-uploads`,

  // Diğer API'ler
  TALEP: `${API_BASE_URL}/api/talep`,
  TALEP_YANIT: `${API_BASE_URL}/api/talep-yanit`,
  TALEP_OKUNDU: `${API_BASE_URL}/api/talep-okundu`,
  OUTCOME_MAPPINGS: (programId, courseId) => `${API_BASE_URL}/api/outcome-mappings/${programId}/${courseId}`,
  CHECK_OUTCOME_MAPPINGS: (programId, courseId) => `${API_BASE_URL}/api/check-outcome-mappings/${programId}/${courseId}`,
  SAVE_OUTCOME_MAPPING: `${API_BASE_URL}/save-outcome-mapping`,
  GET_OUTCOME_MAPPINGS: `${API_BASE_URL}/get-outcome-mappings`,
  GET_MAPPED_PROGRAM_OUTCOMES: `${API_BASE_URL}/get-mapped-program-outcomes`,
  DOWNLOAD_OUTCOME_MAPPING: `${API_BASE_URL}/download-outcome-mapping`,
  DOWNLOAD_QUESTIONS_TEMPLATE: `${API_BASE_URL}/download-questions-template`,

  // Sınav ağırlıkları
  SAVE_EXAM_WEIGHTS: `${API_BASE_URL}/save-exam-weights`,
  GET_EXAM_WEIGHTS: (programId, courseId) => `${API_BASE_URL}/get-exam-weights/${programId}/${courseId}`,

  // Haftalık konular
  WEEKLY_TOPICS: (courseId) => `${API_BASE_URL}/api/weekly-topics/${courseId}`,
  SELECTED_WEEKLY_TOPICS: `${API_BASE_URL}/api/selected-weekly-topics`,
  WEEKLY_NOTES: (programId, courseCode) => `${API_BASE_URL}/api/programs/${programId}/courses/${encodeURIComponent(courseCode)}/weekly-notes`,
  DRIVE_UPLOAD_PDF: `${API_BASE_URL}/drive/upload-pdf`,

  // Aktivite API'leri
  ACTIVITY_HEARTBEAT: `${API_BASE_URL}/api/activity/heartbeat`,
  ACTIVITY_LOGOUT: `${API_BASE_URL}/api/activity/logout`,
  ACTIVITY_ACTIVE_USERS: `${API_BASE_URL}/api/activity/active-users`,
  ACTIVITY_PAST_USERS: `${API_BASE_URL}/api/activity/past-users`,
  ACTIVITY_USAGE_TOTALS: `${API_BASE_URL}/api/activity/usage-totals`,

  // Font API'leri
  FONT_OPENSANS: `${API_BASE_URL}/api/font/opensans-regular`,

  // Sınıf listesi
  CLASS_ROSTER: `${API_BASE_URL}/api/class-roster`,

  // Online sınav girişimleri
  EXAM_ATTEMPTS: (courseId) => `${API_BASE_URL}/api/exam-attempts?course_id=${courseId}`,
  STUDENT_PRETEST_ANALYSIS: (attemptId, courseId) => `${API_BASE_URL}/api/student-pretest-analysis?attempt_id=${attemptId}&course_id=${courseId}`,

  // Genel analiz
  GENERAL_OUTCOME_ANALYSIS: `${API_BASE_URL}/api/general-outcome-analysis`,

  // Yapay Zeka önerileri
  AI_SUGGEST_PROGRAM_OUTCOMES: `${API_BASE_URL}/api/ai/suggest-program-outcomes`,
  AI_SUGGEST_COURSE_TEXT: `${API_BASE_URL}/api/ai/suggest-course-text`,
  AI_ASSESS_LO_ALIGNMENT: `${API_BASE_URL}/api/ai/assess-lo-alignment`,
  AI_MATCH_QUESTION: `${API_BASE_URL}/api/ai-match-question`,
  EDIT_QUESTION_WITH_AI: `${API_BASE_URL}/api/modify-question-with-ai`,

  // Kitapçık oluşturma
  GENERATE_BOOKLETS: `${API_BASE_URL}/api/generate-booklets`,
  GENERATE_BOOKLET_MAPPINGS: `${API_BASE_URL}/api/generate-booklet-mappings`,

  // Soru toplu silme
  BULK_DELETE_QUESTIONS: `${API_BASE_URL}/api/questions/bulk-delete`,

  // Öntest ve Quiz API'leri
  PRETEST_GENERATE: `${API_BASE_URL}/upload`,
  GENERATE_TEST: `${API_BASE_URL}/generate_test`,
  PRETEST_DOWNLOAD: `${API_BASE_URL}/download_test`,
  PRETEST_DOWNLOAD_EXCEL: `${API_BASE_URL}/download_test_excel`,
  QUIZ_CREATE: `${API_BASE_URL}/create_quiz`,
  QUIZ_DOWNLOAD: `${API_BASE_URL}/download_quiz`,
  QUIZ_DOWNLOAD_TXT: `${API_BASE_URL}/download_quiz_txt`,
  MIDTERM_CREATE: `${API_BASE_URL}/create_midterm`,
  MIDTERM_DOWNLOAD: `${API_BASE_URL}/download_midterm`,
  MIDTERM_DOWNLOAD_TXT: `${API_BASE_URL}/download_midterm_txt`,
  DIFFICULTY_CREATE: `${API_BASE_URL}/create_difficulty_questions`,
  DIFFICULTY_DOWNLOAD: `${API_BASE_URL}/download_difficulty_questions`,
  DIFFICULTY_DOWNLOAD_TXT: `${API_BASE_URL}/download_difficulty_questions_txt`,
  EXAM_MATRIX_ANALYZE: `${API_BASE_URL}/upload_exam_matrix`,
  EXAM_MATRIX_TEMPLATE: (group) => `${API_BASE_URL}/download_assignment_template/${group}`,

  // Öntest, Çalışma Konuları ve Kısa Sınav Kaydetme/Listeleme
  SAVE_PRETEST: `${API_BASE_URL}/api/save_pretest`,
  MATCH_QUESTIONS_TO_OUTCOMES: `${API_BASE_URL}/api/match_questions_to_outcomes`,
  SAVE_STUDY_TOPICS: `${API_BASE_URL}/api/save_study_topics`,
  SAVE_QUIZ: `${API_BASE_URL}/api/save_quiz`,
  SAVE_MIDTERM: `${API_BASE_URL}/api/save_midterm`,
  SAVE_HOMEWORK: `${API_BASE_URL}/api/save_homework`,
  GET_PRETESTS: (courseId) => `${API_BASE_URL}/api/get_pretests/${courseId}`,
  GET_STUDY_TOPICS: (courseId) => `${API_BASE_URL}/api/get_study_topics/${courseId}`,
  GET_QUIZZES: (courseId) => `${API_BASE_URL}/api/get_quizzes/${courseId}`,
  GET_MIDTERMS: (courseId) => `${API_BASE_URL}/api/get_midterms/${courseId}`,
  GET_HOMEWORKS: (courseId) => `${API_BASE_URL}/api/get_homeworks/${courseId}`,
  GET_PRETEST: (pretestId) => `${API_BASE_URL}/api/get_pretest/${pretestId}`,
  GET_STUDY_TOPIC: (studyTopicId) => `${API_BASE_URL}/api/get_study_topic/${studyTopicId}`,
  GET_QUIZ: (quizId) => `${API_BASE_URL}/api/get_quiz/${quizId}`,
  GET_MIDTERM: (midtermId) => `${API_BASE_URL}/api/get_midterm/${midtermId}`,
  GET_HOMEWORK: (homeworkId) => `${API_BASE_URL}/api/get_homework/${homeworkId}`,
  DELETE_PRETEST: (pretestId) => `${API_BASE_URL}/api/delete_pretest/${pretestId}`,
  DELETE_STUDY_TOPIC: (studyTopicId) => `${API_BASE_URL}/api/delete_study_topic/${studyTopicId}`,
  DELETE_QUIZ: (quizId) => `${API_BASE_URL}/api/delete_quiz/${quizId}`,
  DELETE_MIDTERM: (midtermId) => `${API_BASE_URL}/api/delete_midterm/${midtermId}`,
  DELETE_HOMEWORK: (homeworkId) => `${API_BASE_URL}/api/delete_homework/${homeworkId}`,
  HOMEWORK_CREATE: `${API_BASE_URL}/create_homework`,

  // Sınav Havuzu Aktarma API'leri
  TRANSFER_TO_EXAM_POOL: `${API_BASE_URL}/api/transfer_to_exam_pool`,
  GET_EXAM_TYPES_FOR_POOL: (courseId) => `${API_BASE_URL}/api/get_exam_types/${courseId}`,

  // Optik Okuma Kaydet
  SAVE_OPTICAL_RESULTS: `${API_BASE_URL}/api/save_optical_results`,
  DOWNLOAD_OPTIC_EXCEL: (sinavId) => `${API_BASE_URL}/api/download_optic_excel/${sinavId}`,
  GENERATE_OPTIC_EXCEL: `${API_BASE_URL}/api/generate_optic_excel`,
  GET_OPTIC_SINAVLAR: (courseId) => `${API_BASE_URL}/api/get_optic_sinavlar/${courseId}`,
  GET_OPTIC_RESULTS: (sinavId) => `${API_BASE_URL}/api/get_optic_results/${sinavId}`,
  GET_OPTIC_DETAIL: (sinavId) => `${API_BASE_URL}/api/get_optic_detail/${sinavId}`,
  DELETE_OPTIC: (sinavId) => `${API_BASE_URL}/api/delete_optic/${sinavId}`,
  GET_COURSE_EXAMS: (courseId) => `${API_BASE_URL}/api/get_course_exams/${courseId}`,
  GET_EXAM_BOOKLET_MAPPING: (examId) => `${API_BASE_URL}/api/get_exam_booklet_mapping/${examId}`,
  GET_STUDENT_LIST: (courseId) => `${API_BASE_URL}/api/student-list?course_id=${courseId}`,
};

export default API_BASE_URL;
